var map = {
	"./CallCenter.png": "659e",
	"./Connect.png": "2b5d",
	"./Contact.png": "a6e5",
	"./Download.png": "70f6d",
	"./Environment.png": "abd9",
	"./Fap.png": "492c",
	"./Map.png": "b952",
	"./MarketPrice.png": "63cd",
	"./Product.png": "a617",
	"./ProductChain.png": "d72b",
	"./View.png": "aa1b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a061";